// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"ProfileDropdownHeader_loginButton__KNAln","headerWrapper":"ProfileDropdownHeader_headerWrapper__x8WyU"};